import React from 'react'
import { Mask, Path } from 'react-native-svg'

interface TerritoryInteriorMaskProps {
  id: string
  shape: string
  regionShape?: string
  borderInset: number
  regionBorderInset: number
}

/** Preserve both the thin cell border and the thicker region perimeter. */
export function TerritoryInteriorMask({ id, shape, regionShape, borderInset, regionBorderInset }: TerritoryInteriorMaskProps) {
  return (
    <Mask id={id}>
      <Path d={shape} fill="#ffffff" fillRule="evenodd" stroke="#000000"
        strokeWidth={2 * borderInset} strokeLinejoin="miter" />
      {regionShape && (
        <Path d={regionShape} fill="none" stroke="#000000"
          strokeWidth={2 * regionBorderInset} strokeLinejoin="round" />
      )}
    </Mask>
  )
}
